import src from "IMAGE";
export default { src, width: 256, height: 46, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABQTEmVHMyN3OygYPTgmFzo2JRY2OicXPBsTDSoKCgo6X50FMpjsONYAAAAASUVORK5CYII="};
